<template>
  <div id="app">
    <!-- <OpdrachtModal v-if="$store.state.selectedOpdrachtId" /> -->
    <Opdracht />

    <div class="ting" v-if="showAllUsersList">
      <div v-for="(e, i) in userAccountsOfTekenaars" :key="i">
        <h3 v-if="e.userProfile && e.userProfile.voornaam && e.userProfile.achternaam">
          <strong>{{ e.userProfile.voornaam || "geen voornaam" }} {{ e.userProfile.achternaam }}</strong>
        </h3>
        {{ e.userProfile || "noprofile" }}
        <br />
        <br />
      </div>
    </div>

    <div v-if="!userLoggedIn" class="login">
      <LoginPopup />
    </div>

    <div class="appwrapper" :class="{ blur: !userLoggedIn }">
      <EmailPopup />

      <!-- Setup Sidebar.vue -->
      <Sidebar />

      <!-- Setup Router App View -->
      <div class="appview">
        <router-view :tekenaars="tekenaars" @select-tekenaar=";(showTekModal = true), (showOpdrModal = false), (showVoegTekenaarToeModal = false), (showVoegOpdrachtToeModal = false), (tekenaarsid = $event)" @select-opdracht=";(showOpdrModal = true), (showTekModal = false), (showVoegTekenaarToeModal = false), (showVoegOpdrachtToeModal = false), (opdrachtid = $event)" @showVoegTekenaarToeModal=";(showVoegTekenaarToeModal = true), (showVoegOpdrachtToeModal = false), (showOpdrModal = false), (showTekModal = false)" @showVoegOpdrachtToeModal=";(showVoegOpdrachtToeModal = true), (showVoegTekenaarToeModal = false), (showOpdrModal = false), (showTekModal = false)" />
      </div>

      <!-- Setup Modal views -->
      <TekModal v-if="showTekModal" :tekenaarsid="tekenaarsid" @close-Modal="showTekModal = false" @select-opdracht=";(showOpdrModal = true), (showTekModal = false), (opdrachtid = $event)" />

      <!-- <NewProfileModal v-if="selectedUserProfileId === 0 || selectedUserProfileId" /> -->
      <NewProfileModal v-if="false" />
      <DannyProfileModal v-if="selectedUserProfileId === 0 || selectedUserProfileId" />

      <OpdrModal v-if="false" />
      <!-- <OpdrModal v-if="showOpdrModal" :opdrachtid="opdrachtid" @close-Modal="showOpdrModal = false" @select-tekenaar=";(showTekModal = true), (showOpdrModal = false), (tekenaarsid = $event)" /> -->
      <VoegTekenaarToeModal v-if="showVoegTekenaarToeModal" @close-Modal="showVoegTekenaarToeModal = false" />
      <VoegOpdrachtToeModal v-if="showVoegOpdrachtToeModal" @close-Modal="showVoegOpdrachtToeModal = false" />
    </div>

    <Radar v-if="false" />
  </div>
</template>

<script>
import { Module as Opdracht } from "@/modules/opdracht"

// import OpdrachtModal from "@/components/v2/opdrachten/modal"
import DannyProfileModal from "./components/pages/Tekenaars/newProfiles/DannyProfileModal"
import { mapActions } from "vuex"
import store from "@/store"

import LoginPopup from "@/components/LoginPopup"
import EmailPopup from "@/components/EmailPopup"

import Sidebar from "@/components/ui-elements/Sidebar"
import TekModal from "@/components/modals/TekModal"
import OpdrModal from "@/components/modals/OpdrModal"

import VoegTekenaarToeModal from "@/components/modals/VoegTekenaarToeModal"
import VoegOpdrachtToeModal from "@/components/modals/VoegOpdrachtToeModal"

import NewProfileModal from "@/components/pages/Tekenaars/newProfiles/NewProfileModal"

import Radar from "@/components/Radar"

export default {
  name: "App",
  components: {
    Radar,
    Opdracht,
    // OpdrachtModal,
    DannyProfileModal,
    NewProfileModal,
    LoginPopup,
    Sidebar,
    TekModal,
    OpdrModal,
    EmailPopup,
    VoegTekenaarToeModal,
    VoegOpdrachtToeModal
  },
  data() {
    return {
      showAllUsersList: false,
      tekenaars: [],
      tekenaarsid: "",
      opdrachtid: "",
      showTekModal: false,
      showOpdrModal: false,

      showVoegTekenaarToeModal: false,
      showVoegOpdrachtToeModal: false
    }
  },
  methods: {
    ...mapActions(["fetchTekenaren", "fetchOpdrachten", "fetchTodos", "fetchStatus"]),
    escapeListener(e) {
      if (e.key === "F1") {
        e.preventDefault()
        this.showAllUsersList = !this.showAllUsersList
      }
    }
  },
  computed: {
    selectedUserProfileId() {
      return store.state.selectedUserProfileId
    },
    userAccountsOfTekenaars() {
      return this.$store.state.userAccounts
    },
    userLoggedIn() {
      return store.state.user.user.loggedIn
    },
    tekFilters() {
      return store.state.tekFilters
    }
  },
  unmounted() {
    window.removeEventListener("keydown", this.escapeListener)
  },
  created() {
    window.addEventListener("keydown", this.escapeListener)

    var currentUrl = window.location.host
    if (currentUrl == "cdt-dev-94ea4.firebaseapp.com") {
      if (window.confirm("Je bezoekt nu de developersversie. Wil je naar de live web app?")) {
        window.location.href = "https://cad-tekenaar.web.app/#/"
      }
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Poppins:400,500,600,800&display=swap");

* {
  -webkit-appearance: none;
}

.ting {
  position: fixed;
  left: 200px;
  top: 100px;
  right: 100px;
  bottom: 100px;
  z-index: 10;
  background-color: white;
  box-shadow: 0 0 1000px rgba(0, 0, 0, 1);
  overflow-y: scroll;
}

.blur {
  filter: brightness(0.9) blur(13px);
  transform: scale(0.98);
  transform-origin: center;
}
.login {
  z-index: 100;
  position: fixed;
  border-radius: 6px;
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/* IPAD VIEW */
.tekmodal .section,
.section .blue {
  position: relative !important;
  top: 0;
}
@media only screen and (max-width: 1024px) {
  .selector {
    font-size: 14px;
  }
  .appview {
    width: 100%;
    overflow-x: hidden;
  }
  .headerholder,
  .itemsheader,
  .tekenaar {
    overflow: hidden;
  }
  .tekmodal .section,
  .section .blue {
    position: relative !important;
    top: 0;
  }

  .teklistemail,
  .teklistbedrijfsnaam,
  .teklisttekenprogramma {
    display: none !important;
  }
  .opdrlistaanvraagdatum,
  .opdrlisttekenaar,
  .opdrliststatus {
    display: none !important;
  }
}

html,
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  font-family: "Poppins", sans-serif;
}
html {
  font-family: "Poppins", sans-serif;
  box-sizing: border-box;
  font-size: 16px;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
img {
  max-width: 100%;
  height: auto;
}
input:focus,
textarea:focus,
select:focus {
  outline: none;
}
.appwrapper {
  display: flex;
  overflow-x: scroll;
  transition: 0.3s;
  overflow-y: hidden;
}
.appview {
  flex: 1;
  /* background-color: #FAFCFE; */
  background-color: #eff2f5;
  min-height: 100vh;
}
.page {
  padding-left: 100px;
  padding-top: 60px;
}
.page-wrapper {
  padding: 60px 40px;
}

.pastel0 {
  background-color: #bbb;
}
.pastel1 {
  background-color: #27a4dd !important;
}
.pastel2 {
  background-color: #9dd5c0 !important;
}
.pastel3 {
  background-color: #f39cc3 !important;
}
.pastel4 {
  background-color: #f1646c !important;
}
.pastel5 {
  background-color: #fac174 !important;
}
.pastel6 {
  background-color: #8794d9 !important;
}
.pastel7 {
  background-color: #b7c8c9 !important;
}
.pastel8 {
  background-color: #e0d44b !important;
}
.pastel9 {
  background-color: #c6a89b !important;
}
.pastel10 {
  background-color: black !important;
}

@media screen and (max-width: 663px) {
  .page {
    padding-left: 0px;
    padding-top: 0px;
  }
  .page-wrapper {
    padding: 20px;
    padding-top: 100px;
  }
}
</style>
